import { STATUS } from "components/constants/statuses";
import {
  CheckCircle,
  CircleDollarSign,
  ListPlus,
  Music,
  X,
  XCircle,
} from "lucide-react";
import { useState } from "react";

const NotificationList = ({ notifications = [] }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="absolute right-0 mt-2 w-80 text-textMain rounded-xl shadow-lg bg-notificationList animate-fade-in">
      <div className="p-4">
        <div className="flex justify-between items-center mb-2">
          <h3 className="font-bold text-lg">Notifications</h3>
          <button
            onClick={() => setIsOpen(false)}
            className="text-textMuted hover:text-white"
          >
            <X size={24} />
          </button>
        </div>
        {notifications.length > 0 ? (
          <ul className="space-y-2">
            {notifications.map((notif) => (
              <li
                key={notif.id}
                className="p-3 rounded-lg shadow-md bg-black/30 flex items-start space-x-3"
              >
                {notif.type === STATUS.APPROVED && (
                  <CheckCircle size={20} className="text-accent" />
                )}
                {notif.type === STATUS.REJECTED && (
                  <XCircle size={20} className="text-red-500" />
                )}
                {notif.type === STATUS.PLAYED && (
                  <Music size={20} className="text-blue-400" />
                )}
                {notif.type === STATUS.PENDING && (
                  <ListPlus size={20} className="text-orange" />
                )}
                {notif.type === STATUS.PAID && (
                  <CircleDollarSign size={20} className="text-blue-400" />
                )}
                <div className="text-sm">
                  {notif.date}
                  <br />{" "}
                  <p className="font-semibold">
                    {notif.trackName} - {notif.artist}
                  </p>
                  {notif.type === STATUS.PLAYED && <p> was played! </p>}
                  {notif.comment && (
                    <p className="text-textMuted text-xs mt-1">
                      <span className="text-textMuted">
                        {" "}
                        DJ's comment: {notif.comment}
                      </span>
                    </p>
                  )}
                  <p
                    dangerouslySetInnerHTML={{ __html: notif.link }}
                    className="text-accent flex items-center space-x-2 pt-1"
                  />
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-textMuted">No new notifications</p>
        )}
      </div>
    </div>
  );
};

export default NotificationList;
